import styled from "styled-components";
import AntSwitch from "antd/es/switch";
import { hexToRGB } from "@shared/utils/misc";

const Switch = styled(AntSwitch)`
  &.ant-switch-checked {
    background: ${(p) => p.theme.colors.primaryBlue}!important;
  }
  ${(p) =>
    p.theme.isDarkMode &&
    `
  &.ant-switch {
    background-color: ${hexToRGB(p.theme.colors.secondaryGrey, 0.25)};
    &:hover {
       background-color: ${hexToRGB(p.theme.colors.secondaryGrey, 0.35)};
    }
  }`};
`;

export default Switch;
